<script>
  exports.install = function (Vue, options) {
    Vue.prototype.handleUnauthorized = function() {
      // 清除 sessionStorage
      sessionStorage.removeItem('verifyData_userid');
      sessionStorage.removeItem('verifyData_username');
      sessionStorage.removeItem('verifyData_cid');
      sessionStorage.removeItem('verifyData_token');
      sessionStorage.removeItem('verifyData_time');
      sessionStorage.removeItem('verifyData_loginType');

      // 使用保存的 Vue 实例引用访问 $router
      if (this.$router) {
        this.$router.push({ path: '/admin' });
      } else {
        window.location.href = '/#/admin';
      }
    },
    Vue.prototype.verifyData=function(){
      return {
        userid: sessionStorage.getItem('verifyData_userid'),
        username: sessionStorage.getItem('verifyData_username'),
        cid: sessionStorage.getItem('verifyData_cid'),
        token: sessionStorage.getItem('verifyData_token'),
        time: sessionStorage.getItem('verifyData_time'),
        loginType: sessionStorage.getItem('verifyData_loginType'),
      };
    }
    Vue.prototype.vhttp = function (vdata) {
      var funThen = {}
      var funCatch = {}
      var config = vdata
      config.url = vdata.url
      var varifyData = {
        userid: sessionStorage.getItem('verifyData_userid'),
        username: sessionStorage.getItem('verifyData_username'),
        cid: sessionStorage.getItem('verifyData_cid'),
        token: sessionStorage.getItem('verifyData_token'),
        time: sessionStorage.getItem('verifyData_time'),
        loginType: sessionStorage.getItem('verifyData_loginType'),
      }
      funThen = vdata.funThen === undefined ? function () {} : vdata.funThen
      funCatch = vdata.funCatch === undefined ? function () {} : vdata.funCatch
      if (config.data !== undefined) {
        config.method = 'post'
      }
      config.data={verifyData: varifyData, body: config.data}
      var selfVue = this
      this.axios_(config)
        .then(function (response) {
          if (typeof response.data !== 'string') {
            if (response.data.code == 401 || response.data.code === undefined) {
              selfVue.handleUnauthorized();
              return
            }
            funThen(response)
          }
          //console.log(response.data)
        })
        .catch(function (error) {
          funCatch(error)
        })
    },
    Vue.prototype.reSetData = function (data) {
      let item = data.filter(t => t.pid == 0)

      function loop (item) {
        for (let i in item) {
          item[i].children = data.filter(t => t.pid  == item[i].id )
          loop(item[i].children)
        }
      }
      loop(item)
      return item
    },
    Vue.prototype.sort_ = function (tarrFrom, key, type = 0) {
      let tarr = tarrFrom
      for (let i = 0; i < tarr.length; i++) {
        for (let v = 0; v < tarr.length; v++) {
          let tmove = false
          if (type === 0 && tarr[i][key]*1 < tarr[v][key]*1) tmove = true
          if (type === 1 && tarr[i][key]*1 > tarr[v][key]*1) tmove = true
          if (tmove === true) {
            let tr = tarr[v]
            tarr[v] = tarr[i]
            tarr[i] = tr
          }
        }
      }
      return tarr
    }
  }
</script>




// WEBPACK FOOTER //
// src/base/base.vue